// Libs
import sum from 'lodash/sum';
// App
import { SelectableProductOptionFormData } from 'app-shared/lib/fragments/product/options-groups';
import { ProductDetails, ShopProductSummary } from 'app-shared/lib/api/catalog/product';
import { Shop, Product, ProductOption } from './bag.slice.interfaces';
import { ShopDetails } from 'app-shared/lib/api/catalog/shop';
import { getSellingPrice } from 'app-shared/lib/utils/product-discount';

// Shop

export const buildBagShop = (shop: ShopDetails): Shop => {
  const mainImageUrl = shop.images.find((image) => image.isMain)?.url;

  const newShop: Shop = {
    id: shop.id,
    name: shop.name,
    type: shop.type,
    mainImageUrl,
    isOnlinePaymentAccepted: shop.isOnlinePaymentAccepted,
    isOnsitePaymentAccepted: shop.isOnsitePaymentAccepted,
    isProTicketsPaymentAccepted: shop.isProTicketsPaymentAccepted,
    currentPlace: shop.currentPlace,
    orderCustomerFees: shop.orderCustomerFees,
    minOrderAmount: shop.minOrderAmount,
  };

  return newShop;
};

// Product

export const buildBagProduct = (
  product: ProductDetails | ShopProductSummary,
  selectedOptionsInForm?: SelectableProductOptionFormData[],
  isAiSuggestion?: boolean
): Product => {
  const mainImageUrl = product.images.find((image) => image.isMain)?.url;
  const hasSelectedOptionsInForm = selectedOptionsInForm?.length;
  const selectedOptionsPriceSupplement =
    (hasSelectedOptionsInForm &&
      sum(selectedOptionsInForm.map((option) => option.quantity * option.priceSupplement))) ||
    0;
  const sellingPrice = getSellingPrice(product);
  const priceWithOptions = sellingPrice + selectedOptionsPriceSupplement;
  const selectedOptions = (hasSelectedOptionsInForm && buildBagProductOptions(selectedOptionsInForm)) || null;

  const newProduct: Product = {
    id: product.id,
    shopId: product.shopId,
    name: product.name,
    price: sellingPrice,
    priceWithOptions,
    mainImageUrl,
    quantity: 0, // this will be calculated later
    minQuantity: product.minSelectableQuantity,
    maxQuantity: product.maxSelectableQuantity,
    selectedOptions,
    isAiSuggestion,
  };

  return newProduct;
};

// Product option

export const buildBagProductOptions = (
  selectableProductOptionsFormData: SelectableProductOptionFormData[]
): ProductOption[] => {
  if (!selectableProductOptionsFormData) return;

  return selectableProductOptionsFormData.map((selectableProductOptionFormData) =>
    buildBagProductOption(selectableProductOptionFormData)
  );
};

export const buildBagProductOption = (
  selectableProductOptionFormData: SelectableProductOptionFormData
): ProductOption => {
  if (!selectableProductOptionFormData) return;

  const productOption: ProductOption = { ...selectableProductOptionFormData };

  return productOption;
};
